<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="4" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="16">
                        <div class="banner-title">{{ $t('sleepAhi.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="time-box">
                <div class="time-item" :class="{'time-active': activeTime === 0}"
                     @click="changeTimeType(0, $t('dailyActive.time3'))">{{ $t('dailyActive.time3') }}
                </div>
                <div class="time-item" :class="{'time-active': activeTime === 1}"
                     @click="changeTimeType(1, $t('dailyActive.time0'))">{{ $t('dailyActive.time0') }}
                </div>
                <div class="time-item" :class="{'time-active': activeTime === 2}"
                     @click="changeTimeType(2, $t('dailyActive.time1'))">{{ $t('dailyActive.time1') }}
                </div>
            </div>
            <div class="time-select">
                <img @click="timeLeft" class="time-icon" :class="{'arr-opacity' : showLeftOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/03left.svg`)">
                <div class="time-date">{{ time }}</div>
                <img @click="timeRight" class="time-icon" :class="{'arr-opacity' : showRightOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
            </div>
            <div class="chart-box-out">
                <div id="chart-box"></div>
                <div class="sleep-start-end-box-ahi sleep-start-end-box" v-if="activeTime == 0">
                    <div class="sleep-start-box">
                        <img src="@/assets/theme/light/status/06sleep/03start.svg">
                        12:14
                    </div>
                    <div class="sleep-start-box">
                        <img src="@/assets/theme/light/status/06sleep/04end.svg">
                        07:14
                    </div>
                </div>
            </div>
            <div class="ahi-legend-box">
                <div class="ahi-legend-item">
                    <div class="ahi-legend-bar ahi-legend-normal"></div>
                    <span class="ahi-legend-text">{{ $t('sleep.ahiNormal') }}</span>
                </div>
                <div class="ahi-legend-item">
                    <div class="ahi-legend-bar ahi-legend-mild"></div>
                    <span class="ahi-legend-text">{{ $t('sleep.ahiMild') }}</span>
                </div>
                <div class="ahi-legend-item">
                    <div class="ahi-legend-bar ahi-legend-moderate"></div>
                    <span class="ahi-legend-text">{{ $t('sleep.ahiModerate') }}</span>
                </div>
                <div class="ahi-legend-item">
                    <div class="ahi-legend-bar ahi-legend-severe"></div>
                    <span class="ahi-legend-text">{{ $t('sleep.ahiSevere') }}</span>
                </div>
            </div>
        </div>
        <div class="ahi-box" v-if="activeTime == 0">
            <div class="ahi-title">AHI</div>
            <div class="ahi-value-box">
                <div class="ahi-value">2.1</div>
                <div class="ahi-unit">events/hr</div>
                <div class="ahi-level ahi-level-normal">NORMAL</div>
            </div>
            <div class="ahi-progress">
                <div class="ahi-progress-normal"></div>
                <div class="ahi-progress-mild"></div>
                <div class="ahi-progress-moderate"></div>
                <div class="ahi-progress-severe"></div>
                <div class="ahi-5">5</div>
                <div class="ahi-15">15</div>
                <div class="ahi-30">30</div>
                <img class="ahi-arr" :src="require(`@/assets/theme/${theme}/status/31sleepAhi/01arr.svg`)">
            </div>
            <div class="ahi-desc">
                The sum of apnea and hypopnea events is less than 5 events per hour, which falls within the normal range
            </div>
        </div>
        <div v-if="activeTime == 0">
            <div class="suggest-title">SPO2</div>
            <div class="ahi-box">
                <div class="bos-math-box">
                    <div class="bos-math-item">
                        <div class="bos-math-title">MIN(04:32)</div>
                        <div class="bos-math-value">93<span class="bos-math-unit">%</span></div>
                    </div>
                    <div class="bos-math-item">
                        <div class="bos-math-title">RANGE</div>
                        <div class="bos-math-value">93-98<span class="bos-math-unit">%</span></div>
                    </div>
                </div>
                <div class="bos-chart-out">
                    <div id="bos-chart"></div>
                    <div id="y-axis-lines">
                        <div style="height: 15%; background-color: var(--chart-color-3);"></div>
                        <div style="height: 10%; background-color: var(--chart-color-5);"></div>
                        <div style="height: 75%; background-color: var(--chart-color-15);"></div>
                    </div>
                </div>
                <div class="sleep-start-end-box sleep-start-end-box-bos">
                    <div class="sleep-start-box">
                        <img src="@/assets/theme/light/status/06sleep/03start.svg">
                        12:14
                    </div>
                    <div class="sleep-start-box">
                        <img src="@/assets/theme/light/status/06sleep/04end.svg">
                        07:14
                    </div>
                </div>
            </div>
        </div>
        <div class="ahi-box" v-if="activeTime != 0">
            <div class="ahi-breakdown-title">AHI BREAKDOWN</div>
            <div class="score-item">
                <div class="score-img-box">
                    <img class="score-img" src="@/assets/theme/light/status/31sleepAhi/02ahiBg.svg">
                    <div v-if="ahiDays" class="score-ratio score-color-1"
                         :style="{'width': ahiRatioArr[0] / ahiDays * 140 + 'px'}"></div>
                    <div class="score-color-bar score-color-1"></div>
                </div>
                <div class="score-text">{{ ahiRatioArr[0] }}{{ $t('sleep.days') }}</div>
                <div class="score-num-level">(＜5)</div>
            </div>
            <div class="score-item">
                <div class="score-img-box">
                    <img class="score-img" src="@/assets/theme/light/status/31sleepAhi/02ahiBg.svg">
                    <div v-if="ahiDays" class="score-ratio score-color-2"
                         :style="{'width': ahiRatioArr[1] / ahiDays * 140 + 'px'}"></div>
                    <div class="score-color-bar score-color-2"></div>
                </div>
                <div class="score-text">{{ ahiRatioArr[1] }}{{ $t('sleep.days') }}</div>
                <div class="score-num-level">(5~14)</div>
            </div>
            <div class="score-item">
                <div class="score-img-box">
                    <img class="score-img" src="@/assets/theme/light/status/31sleepAhi/02ahiBg.svg">
                    <div v-if="ahiDays" class="score-ratio score-color-3"
                         :style="{'width': ahiRatioArr[2] / ahiDays * 140 + 'px'}"></div>
                    <div class="score-color-bar score-color-3"></div>
                </div>
                <div class="score-text">{{ ahiRatioArr[2] }}{{ $t('sleep.days') }}</div>
                <div class="score-num-level">(15~29)</div>
            </div>
            <div class="score-item score-item-last">
                <div class="score-img-box">
                    <img class="score-img" src="@/assets/theme/light/status/31sleepAhi/02ahiBg.svg">
                    <div v-if="ahiDays" class="score-ratio score-color-4"
                         :style="{'width': ahiRatioArr[2] / ahiDays * 140 + 'px'}"></div>
                    <div class="score-color-bar score-color-4"></div>
                </div>
                <div class="score-text">{{ ahiRatioArr[2] }}{{ $t('sleep.days') }}</div>
                <div class="score-num-level">(≥30)</div>
            </div>
        </div>
        <div class="desc-box">
            <div class="desc-title"> APNEA-HYPOPNEA INDEX(AHI)</div>
            <div class="desc-info">
                AHI is the core standard for assessing sleep apnea severity. It represents the average number of "apnea"
                and "hypopnea" events per hour during your sleep.
            </div>
            <div v-if="activeTime == 0">
                <div class="desc-title"> THE LINK BETWEEN AHI & SPO2</div>
                <div class="desc-info">
                    A higher AHI means more frequent breathing interruptions, which directly causes repeated drops in
                    blood oxygen levels. Simply put, AHI reflects the frequency of breathing pauses, while blood oxygen
                    drops indicate the severity of oxygen deprivation.
                </div>
            </div>
            <div class="desc-info desc-last">
                <br>
                According to the international AASM standards, AHI is categorized into 4 levels:
                Green (<5/hr): Normal range; stable breathing.
                Yellow (5-15/hr): Mild risk.
                Orange (15-30/hr): Moderate risk.
                Red (≥30/hr): Severe risk.
                <br>
                <br>
                Note: Results are for reference only. Please consult a doctor if you feel unwell.
            </div>
        </div>
    </div>
</template>

<script>
import {getQueryVariable, getSkin} from '@/utils/comment'
import {
    getToday,
    getNWeekFirstDay,
    getNWeekLastDay,
    getMonthStartDay,
    getMonthEndDay,
    GetDateStr, SwitchTime24,
    changeDate,
    changeMonthDate,
    GetYear, getDateWeek, getDateDay
} from "../../utils/dateUtils";
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'bos',
    data() {
        return {
            ratio: 1,
            theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
            activeTime: 0,
            timeUnit: '',
            time: '',
            startDate: '',
            endDate: '',
            tNum: 0,
            wNum: 0,
            mNum: 0,
            showTimeBox: false,
            bosInfo: {},
            mathData: {},
            myChart: null,
            showLeftOpacity: 0,
            showRightOpacity: 1,
            bosChart: null,
            ahiDays: 12,
            ahiRatioArr: [0, 4, 4, 2], // AHI <5, 5-14, 15-29, ≥30
        }
    },
    watch: {
        showTimeBox: {
            handler(newVal, olVal) {
                if (newVal) {
                    setTimeout(() => {
                        document.addEventListener('click', this.checkClick);
                    }, 0);
                } else {
                    document.removeEventListener('click', this.checkClick);
                }
            }
        }
    },
    mounted() {
        this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
        this.timeUnit = this.$t('bos.time0');
        this.startDate = getToday();
        this.endDate = getToday();
        this.time = getToday().slice(5, 10).replace(/-/g, '/');
        this.getData();
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        },
        checkClick(event) {
            let dom = this.$refs.showContent; // 这里是你的下拉菜单元素
            if (!dom.contains(event.target)) {
                // 不在菜单范围，隐藏即可
                if (this.showTimeBox) {
                    this.showTimeBox = false;
                    document.removeEventListener('click', this.checkClick);
                }
            }
        },
        checkOpacity() {
            if (this.activeTime == 0 && this.tNum <= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 1 && this.wNum >= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 2 && this.mNum >= 0) {
                this.showRightOpacity = 1
            } else {
                this.showRightOpacity = 0
            }
            if (this.activeTime == 0 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 1 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 2 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else {
                this.showLeftOpacity = 0
            }
        },
        timeLeft() {
            if (this.activeTime == 0 && this.startDate > '2020-01-01') {
                this.tNum++;
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.startDate > '2020-01-01') {
                this.wNum--;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 2 && this.startDate > '2020-01-01') {
                this.mNum--;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            this.getData();
        },
        timeRight() {
            if (this.activeTime == 0 && this.tNum > 0) {
                this.tNum--;
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.wNum < 0) {
                this.wNum++;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 2 && this.mNum < 0) {
                this.mNum++;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            this.getData();
        },
        changeTimeType(num, unit) {
            this.activeTime = num;
            this.timeUnit = unit;
            this.showTimeBox = false;
            if (this.activeTime == 1) {
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            }
            if (this.activeTime == 2) {
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            if (this.activeTime == 0) {
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            }
            if (this.activeTime == 3) {
                this.time = GetYear(this.yNum) + '年';
            }
            this.getData();
        },
        getData() {
            this.checkOpacity()
            this.mathData = {}
            if (this.activeTime == 0) {
                this.$api.status.getBos({
                    date: this.startDate
                }).then(res => {
                    if (res.result == 1) {
                        this.mathData.maxData = res.info.bosMax;
                        this.mathData.avgData = res.info.bosAvg;
                        this.mathData.minData = res.info.bosMin;
                        this.bosInfo = res.info;
                        this.$nextTick(function () {
                            this.drawDayChart()
                            this.drawBosChart()
                            this.$forceUpdate()
                        })
                    }
                })
            } else {
                this.$api.status.getBos({
                    startDate: this.startDate,
                    endDate: this.endDate
                }).then(res => {
                    if (res.result == 1) {
                        this.bosInfo = res.info
                        this.mathData.maxData = res.info.maxBos;
                        this.mathData.avgData = res.info.avgBos;
                        this.mathData.minData = res.info.minBos;
                        this.bosInfo.dateArr = [];
                        this.bosInfo.dataMinArr = [];
                        this.bosInfo.dataMaxArr = [];
                        this.bosInfo.dataBasicArr = [];
                        for (let i = 0; i < this.bosInfo.dataBos.length; i++) {
                            this.bosInfo.dateArr.push(this.bosInfo.dataBos[i].date);
                            if (this.bosInfo.dataBos[i].bosMin == this.bosInfo.dataBos[i].bosMax && this.bosInfo.dataBos[i].bosMin > 0) {
                                this.bosInfo.dataMaxArr.push(0.9);
                            } else {
                                this.bosInfo.dataMaxArr.push(this.bosInfo.dataBos[i].bosMax - this.bosInfo.dataBos[i].bosMin);
                            }
                            this.bosInfo.dataMinArr.push(this.bosInfo.dataBos[i].bosMin);

                        }
                        this.$nextTick(function () {
                            this.drawDayChart()
                            this.$forceUpdate()
                        })
                    }
                })
            }
        },
        getItemColor(v) {
            if (v == null) return 'transparent';
            if (v < 5) return getSkin('--chart-color-2');
            if (v <= 15) return getSkin('--chart-color-154');
            if (v <= 30) return getSkin('--chart-color-54');
            return getSkin('--chart-color-4');
        },
        getTopColor(v) {
            if (v == null) return 'transparent';
            if (v < 5) return getSkin('--chart-color-1');
            if (v <= 15) return getSkin('--chart-color-15');
            if (v <= 30) return getSkin('--chart-color-5');
            return getSkin('--chart-color-3');
        },
        drawDayChart() {
            console.log('drawDayChart' + this.activeTime)
            let xData = ['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00'];
            let yData = [4, 5, 16, 100, 12, 13, 14, 15, 16, 17]
            let _this = this;
            if (!this.myChart) {
                this.myChart = this.$echarts.init(document.getElementById("chart-box"));
            }
            if (this.activeTime == 0) {
                if (!this.mathData.avgData) {
                    this.myChart.setOption({
                        grid: {
                            top: 17 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        dataZoom: { // 放大和缩放
                            type: 'inside'
                        },
                        emphasis: {
                            disabled: true,
                        },
                        tooltip: {
                            borderColor: 'transparent',
                            backgroundColor: getSkin('--bg-color-3'),
                            trigger: 'axis',
                            position: (point, params, dom, rect, size) => {
                                let x = point[0] - size.contentSize[0] / 2;
                                let cWidth = 375 * _this.ratio;
                                if (x < 0) {
                                    x = 0;
                                } else if ((x + size.contentSize[0]) > cWidth) {
                                    x = cWidth - size.contentSize[0];
                                }
                                return [x, '0%'];
                            },
                            formatter: function (params, ticket, callback) {
                                let item = params[0];
                                let value = item.data ? item.data + 2 : 0;
                                if (value == 0) {
                                    return
                                }
                                let html = '';
                                html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                                html += '<div style="font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> </div>';
                                return html
                            }
                        },
                        xAxis: {
                            type: 'category',
                            z: 2,
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-3'),
                                }
                            },
                            axisLabel: {
                                show: false,
                            },
                            axisTick: {
                                show: false
                            },
                            data: xData
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            boundaryGap: [0, '10%'],
                            splitNumber: 4,
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3'),
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                showMinLabel: false,
                                fontFamily: "'D-D','SF'",
                                color: getSkin('--text-color-3'),
                            }
                        },
                        series: [
                            {
                                data: yData.map(val => val == null ? null : val - 2),
                                type: 'bar',
                                stack: 'total',
                                barWidth: '50%',
                                lineStyle: {
                                    color: getSkin('--text-color-3'),
                                    width: 2 * this.ratio
                                },
                                itemStyle: {
                                    color: function (params) {
                                        const realValue = yData[params.dataIndex];
                                        return _this.getItemColor(realValue);
                                    },
                                    // borderWidth: barWidth,
                                },
                                label: {
                                    show: true,
                                    position: 'top',
                                    color: getSkin('--text-color-1'),
                                    fontSize: 11 * this.ratio,
                                    fontWeight: 'bold',
                                    formatter: (params) => {
                                        const realVal = yData[params.dataIndex];
                                        if (realVal == null) return '';
                                        if (_this.activeTime == 2) {
                                            // 如果是最大值 或 最小值 → 显示数值
                                            if (realVal === maxVal || realVal === minVal) {
                                                return realVal;
                                            }
                                            // 其他都不显示
                                            return '';
                                        } else {
                                            return realVal;
                                        }

                                    }
                                },
                            },
                            // 上层：顶部亮色部分
                            {
                                type: 'bar',
                                barWidth: '40%',
                                stack: 'total',
                                itemStyle: {
                                    color: function (params) {
                                        const realValue = yData[params.dataIndex];
                                        return _this.getTopColor(realValue);
                                    }
                                },
                                data: yData.map(val => val == null ? null : 1)
                            }
                        ]
                    }, true)
                } else {
                    let data = this.bosInfo.bosData.split(',');
                    let data_style = []
                    for (let i = 0; i < data.length; i++) {
                        let color;
                        if (data[i] >= 95) {
                            color = getSkin('--chart-color-3')
                        } else if (data[i] >= 90) {
                            color = getSkin('--chart-color-8')
                        } else {
                            color = getSkin('--chart-color-10')
                        }
                        let style = {
                            value: data[i],
                            itemStyle: {
                                color: color
                            },
                            emphasis: {
                                itemStyle: {
                                    borderColor: color,
                                    borderWidth: 1.5 * this.ratio,
                                    color: 'transparent'
                                }
                            }
                        }
                        data_style.push(style)
                    }
                    this.myChart.setOption({
                        grid: {
                            top: 35 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        dataZoom: { // 放大和缩放
                            type: 'inside'
                        },
                        tooltip: {
                            borderColor: 'transparent',
                            backgroundColor: getSkin('--bg-color-3'),
                            trigger: 'axis',
                            position: (point, params, dom, rect, size) => {
                                let x = point[0] - size.contentSize[0] / 2;
                                let cWidth = 375 * _this.ratio;
                                if (x < 0) {
                                    x = 0;
                                } else if ((x + size.contentSize[0]) > cWidth) {
                                    x = cWidth - size.contentSize[0];
                                }
                                return [x, '0%'];
                            },
                            formatter: function (params, ticket, callback) {
                                let item = params[0];
                                let value = item.value ? item.value : 0;
                                if (value == 0) {
                                    return
                                }
                                let html = '';
                                html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                                html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> %</div>'
                                return html
                            }
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                interval: 35
                            },
                            axisTick: {
                                show: false
                            },
                            data: ['00:00', '00:10', '00:20', '00:30', '00:40', '00:50', '01:00', '01:10', '01:20', '01:30', '01:40', '01:50', '02:00', '02:10', '02:20', '02:30', '02:40', '02:50', '03:00', '03:10', '03:20', '03:30', '03:40', '03:50', '04:00', '04:10', '04:20', '04:30', '04:40', '04:50', '05:00', '05:10', '05:20', '05:30', '05:40', '05:50', '06:00', '06:10', '06:20', '06:30', '06:40', '06:50', '07:00', '07:10', '07:20', '07:30', '07:40', '07:50', '08:00', '08:10', '08:20', '08:30', '08:40', '08:50', '09:00', '09:10', '09:20', '09:30', '09:40', '09:50', '10:00', '10:10', '10:20', '10:30', '10:40', '10:50', '11:00', '11:10', '11:20', '11:30', '11:40', '11:50', '12:00', '12:10', '12:20', '12:30', '12:40', '12:50', '13:00', '13:10', '13:20', '13:30', '13:40', '13:50', '14:00', '14:10', '14:20', '14:30', '14:40', '14:50', '15:00', '15:10', '15:20', '15:30', '15:40', '15:50', '16:00', '16:10', '16:20', '16:30', '16:40', '16:50', '17:00', '17:10', '17:20', '17:30', '17:40', '17:50', '18:00', '18:10', '18:20', '18:30', '18:40', '18:50', '19:00', '19:10', '19:20', '19:30', '19:40', '19:50', '20:00', '20:10', '20:20', '20:30', '20:40', '20:50', '21:00', '21:10', '21:20', '21:30', '21:40', '21:50', '22:00', '22:10', '22:20', '22:30', '22:40', '22:50', '23:00', '23:10', '23:20', '23:30', '23:40', '23:50', '24:00']
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            boundaryGap: [0, '10%'],
                            min: 60,
                            max: 100,
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            }
                        },
                        series: [
                            {
                                data: data_style,
                                type: 'scatter',
                                symbolSize: 6 * this.ratio,
                            }
                        ]
                    }, true);
                }
            } else {
                xData = this.generateXAxisData()
                if (!this.mathData.avgData) {
                    this.myChart.setOption({
                        grid: {
                            top: 17 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        dataZoom: { // 放大和缩放
                            type: 'inside'
                        },
                        emphasis: {
                            disabled: true,
                        },
                        tooltip: {
                            borderColor: 'transparent',
                            backgroundColor: getSkin('--bg-color-3'),
                            trigger: 'axis',
                            position: (point, params, dom, rect, size) => {
                                let x = point[0] - size.contentSize[0] / 2;
                                let cWidth = 375 * _this.ratio;
                                if (x < 0) {
                                    x = 0;
                                } else if ((x + size.contentSize[0]) > cWidth) {
                                    x = cWidth - size.contentSize[0];
                                }
                                return [x, '0%'];
                            },
                            formatter: function (params, ticket, callback) {
                                let item = params[0];
                                let value = item.data ? item.data + 2 : 0;
                                if (value == 0) {
                                    return
                                }
                                let html = '';
                                html += '<div style="font-size:13px;font-family:D-D;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                                html += '<div style="font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> </div>';
                                return html
                            }
                        },
                        xAxis: {
                            type: 'category',
                            z: 2,
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-3'),
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                color: getSkin('--text-color-3'),
                                fontFamily: "'D-D','SF'",
                                interval: this.activeTime === 2 ? 6 : 0,
                            },
                            axisTick: {
                                show: false
                            },
                            data: xData
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            boundaryGap: [0, '10%'],
                            splitNumber: 4,
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3'),
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                showMinLabel: false,
                                fontFamily: "'D-D','SF'",
                                color: getSkin('--text-color-3'),
                            }
                        },
                        series: [
                            {
                                data: yData.map(val => val == null ? null : val - 2),
                                type: 'bar',
                                stack: 'total',
                                barWidth: '50%',
                                lineStyle: {
                                    color: getSkin('--text-color-3'),
                                    width: 2 * this.ratio
                                },
                                itemStyle: {
                                    color: function (params) {
                                        const realValue = yData[params.dataIndex];
                                        return _this.getItemColor(realValue);
                                    },
                                    // borderWidth: barWidth,
                                },
                                label: {
                                    show: true,
                                    position: 'top',
                                    color: getSkin('--text-color-1'),
                                    fontSize: 11 * this.ratio,
                                    fontWeight: 'bold',
                                    formatter: (params) => {
                                        const realVal = yData[params.dataIndex];
                                        if (realVal == null) return '';
                                        if (_this.activeTime == 2) {
                                            // 如果是最大值 或 最小值 → 显示数值
                                            if (realVal === maxVal || realVal === minVal) {
                                                return realVal;
                                            }
                                            // 其他都不显示
                                            return '';
                                        } else {
                                            return realVal;
                                        }

                                    }
                                },
                            },
                            // 上层：顶部亮色部分
                            {
                                type: 'bar',
                                barWidth: '40%',
                                stack: 'total',
                                itemStyle: {
                                    color: function (params) {
                                        const realValue = yData[params.dataIndex];
                                        return _this.getTopColor(realValue);
                                    }
                                },
                                data: yData.map(val => val == null ? null : 1)
                            }
                        ]
                    }, true)
                } else {
                    let data = this.bosInfo.bosData.split(',');
                    let data_style = []
                    for (let i = 0; i < data.length; i++) {
                        let color;
                        if (data[i] >= 95) {
                            color = getSkin('--chart-color-3')
                        } else if (data[i] >= 90) {
                            color = getSkin('--chart-color-8')
                        } else {
                            color = getSkin('--chart-color-10')
                        }
                        let style = {
                            value: data[i],
                            itemStyle: {
                                color: color
                            },
                            emphasis: {
                                itemStyle: {
                                    borderColor: color,
                                    borderWidth: 1.5 * this.ratio,
                                    color: 'transparent'
                                }
                            }
                        }
                        data_style.push(style)
                    }
                    let xData = this.generateXAxisData();
                    console.log(xData)
                    this.myChart.setOption({
                        grid: {
                            top: 35 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        dataZoom: { // 放大和缩放
                            type: 'inside'
                        },
                        tooltip: {
                            borderColor: 'transparent',
                            backgroundColor: getSkin('--bg-color-3'),
                            trigger: 'axis',
                            position: (point, params, dom, rect, size) => {
                                let x = point[0] - size.contentSize[0] / 2;
                                let cWidth = 375 * _this.ratio;
                                if (x < 0) {
                                    x = 0;
                                } else if ((x + size.contentSize[0]) > cWidth) {
                                    x = cWidth - size.contentSize[0];
                                }
                                return [x, '0%'];
                            },
                            formatter: function (params, ticket, callback) {
                                let item = params[0];
                                let value = item.value ? item.value : 0;
                                if (value == 0) {
                                    return
                                }
                                let html = '';
                                html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                                html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> %</div>'
                                return html
                            }
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                interval: 35
                            },
                            axisTick: {
                                show: false
                            },
                            data: xData
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            boundaryGap: [0, '10%'],
                            min: 60,
                            max: 100,
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            }
                        },
                        series: [
                            {
                                data: data_style,
                                type: 'scatter',
                                symbolSize: 6 * this.ratio,
                            }
                        ]
                    }, true);
                }
            }
        },
        drawBosChart() {
            let _this = this;
            if (!this.bosChart) {
                this.bosChart = this.$echarts.init(document.getElementById("bos-chart"));
            }
            this.bosChart.setOption({
                grid: {
                    top: 16 * this.ratio,
                    bottom: 10 * this.ratio,
                    left: 24 * this.ratio,
                    right: 22 * this.ratio
                },
                dataZoom: { // 放大和缩放
                    type: 'inside'
                },
                tooltip: {
                    borderColor: 'transparent',
                    backgroundColor: getSkin('--bg-color-3'),
                    trigger: 'axis',
                    position: (point, params, dom, rect, size) => {
                        let x = point[0] - size.contentSize[0] / 2;
                        let cWidth = 375 * _this.ratio;
                        if (x < 0) {
                            x = 0;
                        } else if ((x + size.contentSize[0]) > cWidth) {
                            x = cWidth - size.contentSize[0];
                        }
                        return [x, '0%'];
                    },
                    formatter: function (params, ticket, callback) {
                        let item = params[0];
                        let value = item.value ? item.value : 0;
                        if (value == 0) {
                            return
                        }
                        let html = '';
                        html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-2') + '">' + item.axisValue + '</div>'
                        html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-1') + '"><span style="font-size:20px;font-family:D-D;color: ' + getSkin('--text-color-1') + '">' + value + '</span> %</div>'
                        return html
                    }
                },
                xAxis: {
                    type: 'category',
                    axisLine: {
                        lineStyle: {
                            color: getSkin('--line-color-3'),
                        }
                    },
                    axisLabel: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    data: ['00:00', '00:10', '00:20', '00:30', '00:40', '00:50', '01:00', '01:10', '01:20', '01:30', '01:40', '01:50', '02:00', '02:10', '02:20', '02:30', '02:40', '02:50', '03:00', '03:10', '03:20', '03:30', '03:40', '03:50', '04:00', '04:10', '04:20', '04:30', '04:40', '04:50', '05:00', '05:10', '05:20', '05:30', '05:40', '05:50', '06:00', '06:10', '06:20', '06:30', '06:40', '06:50', '07:00', '07:10', '07:20', '07:30', '07:40', '07:50', '08:00', '08:10', '08:20', '08:30', '08:40', '08:50', '09:00', '09:10', '09:20', '09:30', '09:40', '09:50', '10:00', '10:10', '10:20', '10:30', '10:40', '10:50', '11:00', '11:10', '11:20', '11:30', '11:40', '11:50', '12:00', '12:10', '12:20', '12:30', '12:40', '12:50', '13:00', '13:10', '13:20', '13:30', '13:40', '13:50', '14:00', '14:10', '14:20', '14:30', '14:40', '14:50', '15:00', '15:10', '15:20', '15:30', '15:40', '15:50', '16:00', '16:10', '16:20', '16:30', '16:40', '16:50', '17:00', '17:10', '17:20', '17:30', '17:40', '17:50', '18:00', '18:10', '18:20', '18:30', '18:40', '18:50', '19:00', '19:10', '19:20', '19:30', '19:40', '19:50', '20:00', '20:10', '20:20', '20:30', '20:40', '20:50', '21:00', '21:10', '21:20', '21:30', '21:40', '21:50', '22:00', '22:10', '22:20', '22:30', '22:40', '22:50', '23:00', '23:10', '23:20', '23:30', '23:40', '23:50', '24:00']
                },
                yAxis: {
                    type: 'value',
                    position: 'left',
                    min: 60,
                    max: 100,
                    interval: 1,
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        fontSize: 11 * this.ratio,
                        fontFamily: 'D-D',
                        color: getSkin('--text-color-3'),
                        showMinLabel: true,
                        formatter: function (value) {
                            if (value === 90 || value === 94 || value === 100 || value === 60) {
                                return value;
                            }
                            return '';
                        }
                    }
                },
                visualMap: {
                    show: false,
                    type: 'continuous',
                    dimension: 1,
                    min: 90,
                    max: 100,
                    inRange: {
                        color: ['#EFCC3F', '#FBAA40', '#F14A61']
                    }
                },
                series: [
                    {
                        data: [95, 96, 94, 100, 98, 97, 96, 95, 94, 93, 92, 91, 90, 89, 88, 87, 86, 85, 84, 83, 82, 81, 80, 79, 78, 77, 76, 75, 74, 73, 72, 71, 70, 69, 68, 67, 66, 65, 64, 63, 62, 61, 60, 59, 58, 57, 56, 55, 54, 53, 52],
                        type: 'line',
                        smooth: true,
                        symbol: 'none',
                        markLine: {
                            silent: true,
                            symbol: 'none',
                            label: {show: false},
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            },
                            data: [
                                {yAxis: 90},
                                {yAxis: 100}
                            ]
                        }
                    }
                ]
            }, true);
        },
        generateXAxisData() {
            const xData = []
            const start = new Date(this.startDate)
            const end = new Date(this.endDate)
            const current = new Date(start)
            while (current <= end) {
                const dateStr = current.getFullYear() + '-' +
                    (current.getMonth() + 1).toString().padStart(2, '0') + '-' +
                    current.getDate().toString().padStart(2, '0')
                const weekStr = this.$t('sleep.week' + getDateWeek(dateStr))
                xData.push(weekStr + '\n' + getDateDay(dateStr))
                current.setDate(current.getDate() + 1)
            }
            return xData
        },
    }
}
</script>

<style scoped>
.chart-box-out {
    height: 183px;
    width: 100%;
    position: relative;
}

.sleep-start-end-box-ahi {
    position: absolute;
    bottom: 12px;
    width: 310px;
}

#chart-box {
    height: 183px;
    width: 100%;
}

.ahi-box {
    width: 313px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 0px auto 10px;
    padding: 12px 16px;
}

.ahi-title {
    font-size: 13px;
    color: var(--text-color-1);
}

.ahi-breakdown-title {
    font-size: 15px;
    color: var(--text-color-1);
    margin-bottom: 10px;
}

.ahi-legend-box {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    padding-bottom: 12px;
}

.ahi-legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
}

.ahi-legend-bar {
    width: 8px;
    height: 8px;
    border-radius: 2px;
}

.ahi-legend-normal {
    background-color: var(--chart-color-1);
}

.ahi-legend-mild {
    background-color: var(--chart-color-15);
}

.ahi-legend-moderate {
    background-color: var(--chart-color-5);
}

.ahi-legend-severe {
    background-color: var(--chart-color-3);
}

.ahi-legend-text {
    font-size: 11px;
    color: var(--text-color-1);
}

.sleep-start-end-box {
    margin-left: 41px;
    margin-right: 22px;
    display: flex;
    justify-content: space-between;
    font-size: 11px;
    color: var(--text-color-3);
}

.ahi-value-box {
    display: flex;
    color: var(--text-color-1);
    align-items: center;
}

.ahi-value {
    font-size: 24px;
}

.ahi-unit {
    font-size: 13px;
    margin: 0 8px 0 4px;
}

.ahi-level {
    padding: 2px 4px;
    letter-spacing: 2px;
    font-size: 13px;
    line-height: 13px;
    border-radius: 4px;
}

.ahi-level-normal {
    background-color: var(--chart-color-2);
    color: var(--chart-color-1);
}

.ahi-progress {
    width: 313px;
    display: flex;
    margin-top: 15px;
    position: relative;
    color: var(--text-color-3);
    font-size: 11px;
}

.ahi-progress-normal {
    width: 44px;
    height: 10px;
    background-color: var(--chart-color-1);
    border-radius: 2px;
    margin-right: 2px;
}

.ahi-progress-mild {
    width: 87px;
    height: 10px;
    background-color: var(--chart-color-15);
    border-radius: 2px;
    margin-right: 2px;
}

.ahi-progress-moderate {
    width: 133px;
    height: 10px;
    background-color: var(--chart-color-5);
    border-radius: 2px;
    margin-right: 2px;
}

.ahi-progress-severe {
    width: 43px;
    height: 10px;
    background-color: var(--chart-color-3);
    border-radius: 2px;
}

.ahi-5 {
    position: absolute;
    left: 38px;
    bottom: -14px;
}

.ahi-15 {
    position: absolute;
    left: 123px;
    bottom: -14px;
}

.ahi-30 {
    position: absolute;
    left: 255px;
    bottom: -14px;
}

.ahi-desc {
    font-size: 13px;
    color: var(--text-color-2);
    line-height: 18px;
    margin-top: 21px;
}

.ahi-arr {
    position: absolute;
    top: -9px;
    left: 16px;
    width: 18px;
}

.suggest-title {
    color: var(--text-color-2);
    font-size: 15px;
    margin-left: 15px;
    margin-top: 16px;
    letter-spacing: 2px;
    display: flex;
    margin-bottom: 12px;
}

.bos-math-box {
    display: flex;
}

.bos-math-item {
    margin-right: 48px;
}

.bos-math-title {
    font-size: 13px;
    letter-spacing: 2px;
    margin-bottom: 2px;
}

.bos-math-value {
    font-size: 24px;
}

.bos-math-unit {
    font-size: 13px;
    margin-left: 4px;
}

#bos-chart {
    height: 148px;
    width: 100%;
}

.bos-chart-out {
    height: 148px;
    width: 100%;
    position: relative;
}

#y-axis-lines {
    position: absolute;
    left: 24px;
    top: 16px;
    width: 2px;
    bottom: 10px;
}

.sleep-start-end-box-bos {
    margin-left: 24px;
}


.score-item {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
}

.score-item-last {
    margin-bottom: 0;
}

.score-img-box {
    position: relative;
    width: 200px;
}

.score-img {
    position: absolute;
    width: 200px;
    height: 14px;
}

.score-color-bar {
    width: 2px;
    height: 14px;
    border-radius: 3px;
    position: absolute;
    right: 0;
}

.score-color-1 {
    background: var(--chart-color-1);
}

.score-color-2 {
    background: var(--chart-color-15);
}

.score-color-3 {
    background: var(--chart-color-5);
}

.score-color-4 {
    background: var(--chart-color-3);
}

.score-ratio {
    height: 14px;
    border-radius: 3px;
    position: absolute;
    left: 0;
}

.score-text {
    font-size: 13px;
    color: var(--text-color-1);
    margin: 0 0 0 9px;
    width: 57px;
}

.score-num-level {
    font-size: 13px;
    color: var(--text-color-3);
    width: 50px;
    float: left;
}
</style>



// WEBPACK FOOTER //
// src/views/status/31sleepAhi.vue